var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35355 4.64645C9.15829 4.45118 8.84171 4.45118 8.64645 4.64645C8.45118 4.84171 8.45118 5.15829 8.64645 5.35355L9.35355 4.64645ZM16 12L16.3536 12.3536C16.5488 12.1583 16.5488 11.8417 16.3536 11.6464L16 12ZM8.64645 18.6464C8.45118 18.8417 8.45118 19.1583 8.64645 19.3536C8.84171 19.5488 9.15829 19.5488 9.35355 19.3536L8.64645 18.6464ZM8.64645 5.35355L15.6464 12.3536L16.3536 11.6464L9.35355 4.64645L8.64645 5.35355ZM15.6464 11.6464L8.64645 18.6464L9.35355 19.3536L16.3536 12.3536L15.6464 11.6464Z",
    fill: "#14181F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSelect);
export default __webpack_public_path__ + "static/media/arrow-select.d49ee51247cf4315755b8804fd534e3b.svg";
export { ForwardRef as ReactComponent };